import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlider = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 7,
		cy: 9,
		r: 3,
		stroke: "#999999",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9 8H15C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10H11.9C11.75 10.7389 11.4371 11.4186 11.0004 12H15C16.6569 12 18 10.6569 18 9C18 7.34315 16.6569 6 15 6H11.0004C11.4371 6.58141 11.75 7.26112 11.9 8ZM2.99963 6C1.34295 6.0002 0 7.34327 0 9C0 10.6567 1.34295 11.9998 2.99963 12C2.37194 11.1643 2 10.1256 2 9C2 7.87439 2.37194 6.83566 2.99963 6Z",
		fill: "#999999"
	})]
});
export default SvgSlider;
